import {
  Button,
  Container,
  createStyles,
  makeStyles,
  Paper,
  Snackbar,
  TextField,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import firebase from 'firebase';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import Loading from '../../../components/Loading';
import { firestore } from '../../../firebase/firebase';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    subtitle: {
      marginTop: theme.spacing(2),
    },
  })
);

const CreateCompany: React.FC = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [error, setError] = useState(null);

  return (
    <>
      <Paper className={classes.root}>
        <Container>
          <Typography variant="h5" component="h5">
            Work Station Application Form
          </Typography>
          <Formik
            initialValues={{
              applicantName: '',
              icNumber: '',
              contactNumber: '',
              email: '',
              position: '',
              companyName: '',
              ssmNumber: '',
              address: '',
              postcode: '',
              state: '',
              officeNumber: '',
              officeEmail: '',
              recommendedBy: '',
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setShowSnackbar(false);
              setError(null);
              setIsLoading(true);
              firestore
                .collection('companies')
                .add({
                  applicantName: values.applicantName,
                  icNumber: values.icNumber,
                  contactNumber: values.contactNumber,
                  email: values.email,
                  position: values.position,
                  companyName: values.companyName,
                  ssmNumber: values.ssmNumber,
                  address: values.address,
                  postcode: values.postcode,
                  state: values.state,
                  officeNumber: values.officeNumber,
                  officeEmail: values.officeEmail,
                  recommendedBy: values.recommendedBy,
                  timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                })
                .then((docRef) => {
                  setShowSnackbar(true);
                  setError(null);
                  resetForm({});
                  setIsLoading(false);
                })
                .catch((error) => {
                  setShowSnackbar(true);
                  setError(error.ErrorMessage);
                  setIsLoading(false);
                  console.error(error);
                });
            }}
          >
            {({ values, errors, isSubmitting }) => (
              <Form>
                <Typography
                  className={classes.subtitle}
                  variant="h6"
                  component="h6"
                >
                  Applicant Information
                </Typography>
                <Field
                  name="applicantName"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Applicant Name (as per IC/Passport)"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="icNumber"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="IC Number/Passport Number"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="contactNumber"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Contact Number"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="email"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Email Address"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="position"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Position"
                  fullWidth
                  margin="dense"
                />
                <Typography
                  className={classes.subtitle}
                  variant="h6"
                  component="h6"
                >
                  Company Information
                </Typography>
                <Field
                  name="companyName"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Company Name"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="ssmNumber"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="SSM Number"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="address"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Address"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="postcode"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Postcode"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="state"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="State"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="officeNumber"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Office Number"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="officeEmail"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Office Email"
                  fullWidth
                  margin="dense"
                />
                <Field
                  name="recommendedBy"
                  type="input"
                  as={TextField}
                  id="standard-basic"
                  label="Recommended By (IC/SSM No.)"
                  fullWidth
                  margin="dense"
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                >
                  Submit
                </Button>
                {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
              </Form>
            )}
          </Formik>
        </Container>
      </Paper>

      <Loading isLoading={isLoading} />

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity={error ? 'error' : 'success'}
        >
          {error ? error : 'Company profile is created.'}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CreateCompany;
